<template>
    <a style="color: #babbbe; padding: 0px 5px;  position: fixed; right: 5px; bottom: 5px; z-index: 2">
        Copyright © 2023 EduAIR. All rights reserved.
    </a>
</template>

<script>
export default {
    name: 'Footer',
}
</script>